{
  "title": "Nie można ukończyć meldowania",
  "message": "Nie udało się zweryfikować Twojego identyfikatora"
}
